// extracted by mini-css-extract-plugin
module.exports = {"discountBanner":"styles-module--discountBanner--2i1Ul","close":"styles-module--close--3nyZU"};